export default defineNuxtRouteMiddleware(async (_to, from) => {
  const user = useUser()
  const prompt = useAccessedPrompt()

  if (
    !prompt.value
    || (user.value?.id !== prompt.value?.user.id && !user.value?.isAdmin)
  )
    return navigateTo(`/prompt/${from.params.id}`)
})
